import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

var $lang = (navigator.userLanguage || navigator.language).slice(0, 2).toLowerCase()
window.$lang = /^zh/i.test($lang)? 'zh' : 'en'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')